/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Remove repeated mobile captions; retain useful subgroup labels. */
(() => {
  const normalize = text => text.trim().replace(/\s+/g, ' ').toLowerCase();
  function tidyCaptions() {
    document.querySelectorAll('.gm-menu-mobile .gm-tab-links > .gm-item').forEach(item => {
      const label = item.querySelector(':scope > .gm-target .gm-text');
      if (!label) return;
      item.querySelectorAll('.gm-products-grid > li > .gm-heading').forEach(heading => {
        const duplicate = normalize(heading.textContent) === normalize(label.textContent);
        heading.parentElement.classList.toggle('cmw-repeated-caption', duplicate);
      });
    });
  }
  tidyCaptions();
  const menu = document.querySelector('#mobile-menu');
  if (menu) new MutationObserver(tidyCaptions).observe(menu, {childList: true, subtree: true});
})();

/* Anchor the mobile overlay below the visible announcement bar. */
(() => {
  function positionMobileMenu() {
    const bar = document.querySelector('.announcement-bar');
    const bottom = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--cmw-mobile-menu-top', bottom + 'px');
  }
  positionMobileMenu();
  window.addEventListener('resize', positionMobileMenu, {passive:true});
  window.addEventListener('scroll', positionMobileMenu, {passive:true});
  const bar = document.querySelector('.announcement-bar');
  if (bar) new ResizeObserver(positionMobileMenu).observe(bar);
})();
/* Some Globo initializations attach the mobile menu to the desktop slot. */
(() => {
  let movedMenu, desktopParent;
  window.addEventListener('resize', () => {
    if (movedMenu && !window.matchMedia('(max-width: 767px)').matches) {
      movedMenu.classList.remove('mobile-menu__nav');
      movedMenu.classList.add('nav-bar__linklist');
      desktopParent.append(movedMenu);
      movedMenu = null;
    }
    placeGloboMenu();
  });
  function placeGloboMenu() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    const panel = document.querySelector('#mobile-menu .mobile-menu__section');
    const menu = document.querySelector('.nav-bar .gm-menu.gm-menu-mobile');
    if (!panel || !menu || panel.querySelector('.gm-menu')) return;
    const original = panel.querySelector('.mobile-menu__nav');
    if (original) original.style.display = 'none';
    desktopParent = menu.parentElement; movedMenu = menu;
    menu.classList.remove('nav-bar__linklist');
    menu.classList.add('mobile-menu__nav');
    panel.prepend(menu);
  }
  placeGloboMenu();
  new MutationObserver(placeGloboMenu).observe(document.body, {childList:true, subtree:true});
})();
/* Keep product panels paired with mobile headings after Globo initializes. */
(() => {
  const relocated = new Map();
  function syncPanels() {
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    if (!mobile) {
      relocated.forEach((home, panel) => {
        if (home.isConnected && panel.isConnected) home.append(panel);
      });
      relocated.clear();
      return;
    }
    document.querySelectorAll('#mobile-menu .gm-tabs').forEach(tabs => {
      const links = tabs.querySelector(':scope > .gm-tab-links');
      const contents = tabs.querySelector(':scope > .gm-tab-contents');
      if (!links || !contents) return;
      [...contents.children].forEach(home => {
        const panel = home.querySelector(':scope > .gm-tab-panel');
        const index = home.getAttribute('data-tab-index');
        const heading = [...links.children].find(item => item.getAttribute('data-tab-index') === index);
        if (!panel || !heading || heading.querySelector(':scope > .gm-tab-panel')) return;
        relocated.set(panel, home);
        heading.append(panel);
      });
    });
  }
  const menu = document.querySelector('#mobile-menu');
  if (menu) new MutationObserver(syncPanels).observe(menu, {childList:true, subtree:true});
  window.addEventListener('resize', syncPanels);
  syncPanels();
})();
